import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2 text-center">
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 mb-8 text-center">关于吃瓜51，你想知道的都在这里</p>
        <div className="space-y-3">
          {faqData.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggle(faq.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
                >
                  <h3 className="text-sm font-bold text-foreground-950 pr-4">{faq.question}</h3>
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full bg-background-200 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-foreground-600 text-sm"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}